<template>
    <div class="home-main-container">
        <!-- 경고 문구 -->
        <div v-if="showWarning" class="warning-message"> 
            <!-- <span class="icon" style="border: 1px solid red;">❗</span> -->
            <span class="icon">※</span>
            시스템 사용은 모니터링, 기록 및 감사 대상이 될 수 있습니다.
            <button @click="showWarning = false" style="margin-left:auto;font-size:0.95em;color:#c82333;background:none;border:none;cursor:pointer;">닫기</button>
        </div>
        <div class="main-center">
            <div class="card-group">
                <div class="card" @click="goToRegister">
                    <img src="@/assets/resource/icon/Register.png" alt="환자 등록" />
                    <div>환자 등록</div>
                </div>
                <div class="card" @click="goToList">
                    <img src="@/assets/resource/icon/Load.png" alt="환자 목록" />
                    <div>환자 목록</div>
                </div>
            </div>
        </div>

<!--        <div class="device-status" @click="toggleConnect">-->
<!--            <div class="status-row">-->
<!--                <span class="bluetooth-icon"></span>-->
<!--                <span class="status-label">장비 연결 상태</span>-->
<!--&lt;!&ndash;                <span class="setting-icon" @click="openDeviceSettings($event)"></span>&ndash;&gt;-->
<!--            </div>-->
<!--            <div v-if="!bleState.deviceConnected.value" class="status-row error">-->
<!--                <span class="error-icon"></span>-->
<!--                <span>기기 연결 상태를 확인 해주세요.</span>-->
<!--            </div>-->
<!--            <div v-if="bleState.deviceConnected.value" class="status-row conn">-->
<!--                <span class="conn-icon"></span>-->
<!--                <span>{{ bleState.deviceName.value }}</span>-->
<!--                <span>{{ bleState.isReady.value ? '통신 준비 완료' : '통신 준비 중' }}</span>-->
<!--            </div>-->
<!--        </div>-->

        <div class="device-status" @click="toggleConnect">
            <div class="status-row header">
                <span class="bluetooth-icon"></span>
                <span class="status-label">기기 연결 상태</span>
            </div>
            <div v-if="!bleState.deviceConnected.value" class="status-row error">
                <!-- <span class="error-icon"></span> -->
                <span class="error-text">⚠️ 기기를 연결하려면 여기를 클릭하세요</span>
            </div>
            <div v-if="bleState.deviceConnected.value" class="status-row conn">
                <span class="conn-icon"></span>
                <span>{{ bleState.deviceName.value }}</span>
                <!-- <span class="ready-text">{{ bleState.isReady.value ? '✅ 통신 준비 완료' : '⏳ 통신 준비 중' }}</span> -->
                <span class="ready-text">{{ bleState.isReady.value ? '통신 연결 완료' : '통신 준비 중' }}</span>
            </div>
        </div>
    </div>
</template>
<script setup>
    import { inject, ref, onMounted  } from 'vue'
    import { useRouter } from 'vue-router'

    // BLE 상태와 액션 주입
    const bleState = inject('bleState')
    const bleActions = inject('bleActions')

    // const showWarning = ref(false);
    const showWarning = ref(true);
    const router = useRouter()

    const toggleConnect = () => {
        // if(bleState.deviceConnected.value){
        //     bleActions.disconnectDevice()
        // } else {
        //     bleActions.connectDevice()
        // }
        bleActions.connectDevice()
    }

    function goToRegister() {
        router.push('/patientadd/patientadd')
    }

    function goToList() {
        router.push('/patientlist/patientlist')
    }

    function openDeviceSettings(event) {
        event.preventDefault()
        event.stopPropagation()
        
        if (typeof window.Android !== 'undefined') {
            Android.openBluetoothSettings()
        } else {
            alert('블루투스 설정을 열 수 없습니다')
        }
    }

    const PatientListFilter = {
        searchType: "all",
        searchText: "",
        startDate: "",
        endDate: "",
        sortOption:"recently"
    };

    onMounted(() => {
        if (!sessionStorage.getItem('hasShownLoginWarning')) {
            showWarning.value = true;
            sessionStorage.setItem('hasShownLoginWarning', 'true');
        }
        sessionStorage.setItem('PatientListPage', '1');
        sessionStorage.setItem('PatientListFilter', JSON.stringify(PatientListFilter));
    });
</script>
